import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { UserSecurityProfileDto } from '../../models/userSecurityProfileDto';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrl: './permission.component.scss'
})

export class PermissionComponent {
  permissionsDetails!: UserSecurityProfileDto;
  isPermissionsAvailable = false;
  groupedPermissions: { type: string, items: any[] }[] = [];
  activeQueueIndex: number = -1;

  constructor(
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly dialogRef: MatDialogRef<PermissionComponent>
  ) { }

  ngOnInit(): void {
    this.getPermissionsDetails();
  }

  getPermissionsDetails(): void {
    this.commonService.getUserPermissions(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId).subscribe({
      next: (response: UserSecurityProfileDto) => {
        this.permissionsDetails = response;
        this.groupPermissions();
        this.isPermissionsAvailable = true;
      },
      error: (error: any) => {
        this.isPermissionsAvailable = false;
      }
    })
  }

  groupPermissions(): void {
    const grouped = new Map<string, any[]>();
    const elements = this.permissionsDetails.objectSecurityGrid.objectSecurityElements;
    for (const item of elements) {
      const type = item.objectTypeAsString;
      if (!grouped.has(type)) {
        grouped.set(type, []);
      }
      grouped.get(type)!.push(item);
    }
    this.groupedPermissions = Array.from(grouped.entries()).map(([type, items]) => ({
      type,
      items
    }));
  }

  getPermissionsQueues(queue: number) {
    if (this.activeQueueIndex !== queue) {
      this.activeQueueIndex = queue;
    } else {
      this.activeQueueIndex = -1; // Toggle off if already selected
    }
  };

  isOpenQueue(queue: number): boolean {
    return this.activeQueueIndex === queue;
  }
  
  onCancelClick(): void {
    this.dialogRef.close('ok');
  }
}
